import React from "react"

import { getMetricColorForMetric } from "@/metrics/metric-display"

import type { TestCaseRecord } from "@/types/api/TestCaseRecord"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { AUDIO_REGION_COLOR_BY_CLASSIFICATION } from "../audio-metric-constants"
import { WithAudioFilterMixin } from "../mixins/WithAudioFilterMixin"
import { WithLLMAudioRegionsMixin } from "../mixins/WithLLMAudioRegionsMixin"
import { CategoricalLLMMetricRecord } from "./CategoricalLLMMetricRecord"

type BaseTestCaseRecord = Pick<
  TestCaseRecord,
  "input_str" | "expected_behaviors" | "expected_output_json"
>

export class AudioCategoricalLLMMetricRecord extends WithLLMAudioRegionsMixin(
  WithAudioFilterMixin(CategoricalLLMMetricRecord),
) {
  documentation = this.metric_metadata?.question || this.description

  _renderDeepDive(
    mo: RunMetricOutput,
    _testCase?: BaseTestCaseRecord,
  ): React.ReactNode {
    const parentContent = super._renderDeepDive(mo)
    const audioSection = this._renderAudioObservationsSection(mo)
    if (!audioSection) {
      return parentContent
    }
    return <div className="space-y-8">{audioSection}</div>
  }

  get supportsAudioSegmentReview(): boolean {
    return false
  }

  getAudioRegionColorForVerdict(verdict: string | null): string | undefined {
    if (!verdict) {
      return AUDIO_REGION_COLOR_BY_CLASSIFICATION.default
    }
    // Categorical: match the category name against the metric's target via the
    // shared classifier. Matching values render success, non-matching render danger.
    const classification = getMetricColorForMetric(verdict, this)
    return AUDIO_REGION_COLOR_BY_CLASSIFICATION[classification]
  }

  renderMetricType(): React.ReactNode {
    return "Audio Categorical"
  }
}
